import React, { useState } from 'react';
import { Input } from '../ui/Input';
import { Toggle } from '../ui/Toggle';
import { DatePicker } from '../ui/DatePicker';
export function BasicTab() {
  const [makerChecker, setMakerChecker] = useState(false);
  const [isActive, setIsActive] = useState(true);
  return <div className="space-y-6 max-w-4xl animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-503">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-504">
        <Input label="Product ID" value="AUTO-GENERATED" disabled className="bg-gray-50 text-gray-500" data-id="element-505" />
        <Input label="Product Code" placeholder="e.g. PL-STD-001" required data-id="element-506" />
        <Input label="Product Name" placeholder="e.g. Personal Loan Standard" required data-id="element-507" />
        <div className="flex items-end pb-2" data-id="element-508">
          <Toggle label="Maker-Checker Required" checked={makerChecker} onChange={setMakerChecker} helperText="Requires approval workflow for changes" data-id="element-509" />
        </div>
      </div>

      <Input type="textarea" label="Product Description" placeholder="Enter detailed description of the loan product..." data-id="element-510" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-511">
        <DatePicker label="Valid From" required data-id="element-512" />
        <DatePicker label="Valid To" required data-id="element-513" />

        <div className="pt-2" data-id="element-514">
          <Toggle label="Status" checked={isActive} onChange={setIsActive} helperText={isActive ? 'Product is currently Active' : 'Product is currently Inactive'} data-id="element-515" />
        </div>
      </div>
    </div>;
}